import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import { MainDrawDay } from 'constants/Draw';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { colors } from 'utils/constants';
import DrawDaysSelector from '../draw-days-selector/DrawDaysSelector';
import { EntryMethod, EntryMethodDetails } from '../EntryMethod';
import NewSelectEntriesSection from '../NewSelectEntriesSection';

interface IEditMyEntries {
  setEditingEntries: (editing: boolean) => void;
}

export const EditMyEntries = observer(
  ({ setEditingEntries }: IEditMyEntries) => {
    const {
      dayEnabled,
      lines,
      setLines,
      setLineNumber,
      setLineBonusNumber,
      removeLine,
      generateLineRandomNumbers,
      entryMethod,
      setDays,
    } = useEnterStore();

    const [unsavedTuesdayDrawEnabled, setUnsavedTuesdayDrawEnabled] = useState(
      dayEnabled.TUESDAY
    );
    const [unsavedFridayDrawEnabled, setUnsavedFridayDrawEnabled] = useState(
      dayEnabled.FRIDAY
    );

    const [editedLines, setEditedLines] = useState(false);
    const [interactedWithDrawDaysSelector, setInteractedWithDrawDaysSelector] =
      useState(false);

    const showDrawDaysSelector =
      entryMethod === EntryMethod.PremiumSubscription ||
      entryMethod === EntryMethod.LiteSubscription;

    return (
      <div className="editMyEntries grid gap-2em">
        <div className="grid gap-1em fullWidth">
          <div className="fullWidth flexCentered">
            <p className="medium xbold">Edit my entries</p>

            <p>
              Tap a field below to edit a number or select the 'X' icon to
              delete an entry
            </p>
          </div>

          <NewSelectEntriesSection
            lines={lines}
            setLines={setLines}
            setLineNumber={setLineNumber}
            setLineBonusNumber={setLineBonusNumber}
            removeLine={removeLine}
            generateLineRandomNumbers={generateLineRandomNumbers}
            glowColor={EntryMethodDetails[entryMethod]?.underlineGlowColor}
            noBorder
            locked={false}
            loading={false}
          />
        </div>

        {showDrawDaysSelector && (
          <>
            <Separator
              // @ts-ignore
              margin={0}
            />
            <DrawDaysSelector
              tuesdayDrawEnabled={unsavedTuesdayDrawEnabled}
              setTuesdayDrawEnabled={setUnsavedTuesdayDrawEnabled}
              fridayDrawEnabled={unsavedFridayDrawEnabled}
              setFridayDrawEnabled={setUnsavedFridayDrawEnabled}
              onAnyUserAction={() => setInteractedWithDrawDaysSelector(true)}
              collapsible
              useDefaultHeading
            />
            <Separator
              // @ts-ignore
              margin={0}
            />
          </>
        )}

        <RoundedButton
          onClick={() => {
            // Save any changes to lines or draw days
            if (editedLines) {
            }

            const days = [] as MainDrawDay[];
            if (unsavedTuesdayDrawEnabled) {
              days.push(MainDrawDay.TUESDAY);
            }
            if (unsavedFridayDrawEnabled) {
              days.push(MainDrawDay.FRIDAY);
            }
            setDays(days);

            setEditingEntries(false);
          }}
          href={undefined}
          className={undefined}
          id={undefined}
          disabled={undefined}
          hoverColor={undefined}
          hoverTextColor={undefined}
        >
          Done
        </RoundedButton>

        <div className="cancelButton" onClick={() => setEditingEntries(false)}>
          Cancel
        </div>

        <style jsx>
          {`
            .cancelButton {
              font-weight: 700;
              color: ${colors.primaryBrandGray}80;
              margin-top: 1em;
              cursor: pointer;
            }

            :global(.editMyEntries .selectEntriesSection .separator),
            :global(.editMyEntries .selectEntriesSection .andSaveBanner) {
              display: none;
            }
          `}
        </style>
      </div>
    );
  }
);
